/* eslint-disable react/prop-types */

import { forwardRef, ReactNode } from 'react';
import { CircularProgress } from '@mui/material';
import { Button } from '../base';
import { BaseButtonProps } from '../types';

export interface LoadingButtonProps extends BaseButtonProps {
  loading?: boolean;
  children: ReactNode;
}

export const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>((props, ref) => {
  const { loading = false, children, ...rest } = props;

  return (
    <Button ref={ref} loading={loading} loadingPosition="center" {...rest}>
      {loading ? <CircularProgress size={20} color="inherit" /> : children}
    </Button>
  );
});

LoadingButton.displayName = 'LoadingButton';
